module.exports = __webpack_public_path__ + "img/nanshashidi.cf510f95.jpg";